/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Funnels", description = "Hightouch's Customer Studio Funnels helps you pinpoint funnel drop-offs and track conversion rates over time.", lastUpdatedDate = new Date(1755561600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Funnels",
        description: "Hightouch's Customer Studio Funnels helps you pinpoint funnel drop-offs and track conversion rates over time.",
        lastUpdatedDate: "Tue Aug 19 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }, {
          "value": "Building a Funnel",
          "depth": 1,
          "id": "building-a-funnel"
        }, {
          "value": "Compare Segments",
          "depth": 1,
          "id": "compare-segments"
        }, {
          "value": "Create an Audience",
          "depth": 1,
          "id": "create-an-audience"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      h3: "h3",
      img: "img",
      ol: "ol",
      li: "li"
    }, _provideComponents(), props.components), {Video, IntegrationsCount} = _components;
    if (!IntegrationsCount) _missingMdxReference("IntegrationsCount", true);
    if (!Video) _missingMdxReference("Video", true);
    return _jsxs(_Fragment, {
      children: [_jsx(Video, {
        source: "https://cdn.sanity.io/files/pwmfmi47/production/91027628b2a576d351b003e9c45170c4338888d3.mp4",
        title: "Funnel chart overview"
      }), "\n", _jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "Funnels are an easy way to explore where dropoff occurs across a customer's journey or analyze any sequence of events. This is important to understand which touch points need to be improved to improve overall conversion rate."
      }), "\n", _jsx(_components.h3, {
        id: "building-a-funnel",
        children: "Building a Funnel"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.img, {
          src: "campaign-intel/funnel_basic.png",
          alt: "Analytics funnels"
        }), "\nTo build a funnel analysis in Hightouch, follow these steps:"]
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Select Starting Event: Choose the initial event to analyze. This can be any specific or general event."
        }), "\n", _jsx(_components.li, {
          children: "Add Event Properties: Apply filters to events by selecting property names and values."
        }), "\n", _jsx(_components.li, {
          children: "Define Event Sequence: Choose additional events and set the order (exact order, any order, this order)."
        }), "\n", _jsx(_components.li, {
          children: "Segment Users: Identify and segment the user base for the analysis by adding properties or importing saved segments."
        }), "\n"]
      }), "\n", _jsx(_components.h3, {
        id: "compare-segments",
        children: "Compare Segments"
      }), "\n", _jsxs(_components.p, {
        children: ["While funnels tell you where your customers are dropping off overall, it doesn't tell you who is dropping off at each point. Get deeper insights by comparing conversion paths against different segments, user properties, or event properties.\n", _jsx(_components.img, {
          src: "campaign-intel/funnel_compare.png",
          alt: "Analytics funnels"
        })]
      }), "\n", _jsx(_components.h3, {
        id: "create-an-audience",
        children: "Create an Audience"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you know who is dropping off where, you are in a great spot to nudge them past this point. You can create an audience by selecting on the chart where you can then sync it to any of our ", _jsx(IntegrationsCount, {}), " destinations.\n", _jsx(_components.img, {
          src: "campaign-intel/create_audience_funnel.png",
          alt: "Analytics funnels"
        })]
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
